import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter } from "@angular/core";
import { SharedService, copyToClipboard } from '../../shared';
import { CamProductList } from "../../dateneingabe-frageboge/productList";
import { CamProductList_EN } from "../../dateneingabe-frageboge/productList-en";
import { LANGUAGE_ENUM, getCategoryLabel } from "../../dateneingabe-frageboge/questionnaire.model";


@Component({
    selector: 'app-rezept-config-popup',
    templateUrl: "./rezept-config-popup.component.html",
    styleUrls: ["./rezept-config-popup.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class RezeptConfigPopupComponent implements OnInit {
    @Input() LANGUAGE: LANGUAGE_ENUM = LANGUAGE_ENUM.DE;
    @Input() camObj: any;

    LANGUAGE_ENUM = LANGUAGE_ENUM;

    cannabisText: any = "";
    rezeptangabenText: any = "";

    cannabisDDL: any[] = [];

    @Output() onBtnCLick: EventEmitter<any> = new EventEmitter();

    get rezeptText() {
        return this.cannabisText && this.cannabisText.length ? this.cannabisText + "\n" + this.rezeptangabenText : this.rezeptangabenText;
    }

    get hasColumnView() {
        return this.jsPanelContentWidth < 960 ? true : false;
    }

    get showDropdown() {
        return this.cannabisDDL.length > 0;
    }

    get jsPanelContentWidth() {
        if (document.getElementsByClassName("jsPanel-content").length) {
            return document.getElementsByClassName("jsPanel-content")[0].clientWidth;
        }
        else {
            return document.body.clientWidth;
        }
    }

    constructor(private sharedService: SharedService) {

    }

    ngOnInit(): void {
        this.cannabisText = this.getCamTherapieLabel();
        this.fnSetCannabisDDL();
    }

    getCamProductOptions(label) {
        if (this.LANGUAGE == LANGUAGE_ENUM.EN) {
            return CamProductList_EN.find(a => a.label == label)?.options || [];
        } else {
            return CamProductList.find(a => a.label == label)?.options || [];
        }
    }

    fnSetCannabisDDL() {
        this.cannabisDDL = [];
        let category = this.camObj.category.value;
        var label = getCategoryLabel(category, this.LANGUAGE);
        switch (label) {
            case 'Blüten':
            case 'Extrakte':
            case 'Kapseln':
            case 'Flowers':
            case 'Extracts':
            case 'Capsules':
                {
                    let product = this.camObj.product.value;
                    if (product) {
                        let data = this.getCamProductOptions(label);
                        let camCategory = data.find(a => a.label == product)?.category;
                        if (camCategory) {
                            data = data.filter(a => a.category == camCategory && a.partner);
                            data.forEach((item) => {
                                let text = item.partner ? item.label : `${category} ${item.thc_cbd}`;
                                this.cannabisDDL.push(text);
                            });
                        }
                    }
                }
                break;
            default:
                this.cannabisDDL = [];
                break;
        }

    }

    getCamTherapieLabel() {
        let freeText = this.camObj.product.freeText;
        if (freeText) {
            return freeText;
        } else {
            let category = this.camObj.category.value;
            let product = this.camObj.product.value;
            if (product) {
                var label = getCategoryLabel(category, this.LANGUAGE);
                let data = this.getCamProductOptions(label);
                let item = data.find(a => a.label == product);
                if (item) {
                    let text = item.partner ? item.label : `${category} ${item.thc_cbd}`;
                    return text;
                }
            }
            return category;
        }
    }

    printRezept() {
        this.onBtnCLick.emit('PrintRezept');
        var html = document.getElementById("print-rezept-gelb").outerHTML;
        this.sharedService.printHTMLData(html, {
            headCss: true
        });
    }

    copyRezept() {
        this.onBtnCLick.emit('CopyRezept');
        copyToClipboard(this.rezeptText);
    }
}
